import { FC } from 'react'
import { ErrorMessage } from '@hookform/error-message'
import { FieldErrors } from 'react-hook-form'
import styles from './styles.module.scss'
import { AddressData, CustomerDetailsData } from '../../../config'

export interface InputErrorProps {
  name: string
  errors: FieldErrors<
    AddressData | (CustomerDetailsData & { customError?: string })
  >
}

export const ErrorField = ({ message }: { message: string }) => (
  <p className={styles.inputError}>{message}</p>
)

export const InputErrorMessage: FC<InputErrorProps> = ({ errors, name }) => {
  return (
    <ErrorMessage
      errors={errors}
      name={name}
      render={({ message }) => <ErrorField message={message} />}
    />
  )
}
